import React, { useEffect, useState, Fragment } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

import "../static/css/homecompanyres.css";
import krezco from "../static/images/krezco-logo.PNG";
import Modal from "react-bootstrap/Modal";
import useOnceEffect from "../Hooks/useOnceEffect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faBell,
  faBriefcase,
  faLaptop,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import reporte from "../static/images/reportes.svg";
import user from "../static/images/user_default.png";
import useToggle from "../Hooks/useToggle";
import { ExportExcel } from "../utils/Excel/exportExcel";
import { colors } from "@material-ui/core";
import DatesPicker from "../utils/DatesPicker";
import moment from "moment";

function HeaderProfile({
  profile,
  rol,
  end,
  formacionend,
  unreadNotificationCount,
}) {
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [path, setPath] = useState("");
  const [endlink, setendlink] = useState("");
  const [Fendlink, setFendlink] = useState("");
  const handleClose = () => setShow(false);
  const [Reportes, togglereporte] = useToggle(false);

  const [companyData, setcompanyData] = useState("");
  //Validamos que el perfil este completado, de lo contrario lo redireccionamos a la pagina perfil

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("tok");

  let userId = localStorage.getItem("userId");

  useEffect(() => {
    const pp = document.getElementById("headerProfilePic");
    if (profile != null) {
      pp.src = profile;
    }
    if (rol === "company") {
      setPath("/company");
    }
    if (rol === "applicant") {
      setPath("/user");
    }
    if (rol === "institute") {
      setPath("/CentroFormacion");
    }
  }, [profile, rol]);

  useEffect(() => {
    const pp = document.getElementById("headerProfilePic");

    if (end != null) {
      pp.src = end;
    }
    if (rol === "company") {
      setendlink("/Vacante/Publica");
    }
    if (rol === "applicant") {
      setendlink("/Empleos");
    }
    if (rol === "institute") {
      setendlink("/Vacante/Publica");
    }
  }, [end, rol]);

  useEffect(() => {
    const pp = document.getElementById("headerProfilePic");
    if (formacionend != null) {
      pp.src = formacionend;
    }
    if (rol === "company") {
      setFendlink("/Formacion");
    }
    if (rol === "applicant") {
      setFendlink("/Formacion");
    }
    if (rol === "institute") {
      setFendlink("/Formacion/Publica");
    }
  }, [formacionend, rol]);

  useOnceEffect(() => {
    axios.get("access/company/" + userId).then((result) => {
      if (result.status === 200) {
        setcompanyData(result.data);
      } else if (result.status === 400) {
        toast.error(
          result.errors[0].field + " " + result.errors[0].defaultMessage
        );
      } else toast.error(result.message);
    });
  });

  function logOut() {
    localStorage.clear();
    history.push("/");
  }

  function sinFuncionalidad() {
    setShow(true);
  }

  function sinFuncionalidadOk() {
    setShow(false);
  }

  const pp = {
    borderRadius: "50%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
  };

  const setActiveTab = (id) => {
    let links = [].slice.call(document.getElementsByClassName("nav-link"));

    links.forEach((elm) => {
      elm.classList.remove("active");
    });

    id.classList.add("active");
  };

  useEffect(() => {
    let location;

    if (rol === "applicant") {
      location = history.location.pathname.slice(6).toLowerCase();
    } else if (rol === "company") {
      location = history.location.pathname.slice(9).toLowerCase();
    } else if (rol === "institute") {
      location = history.location.pathname.slice(17).toLowerCase();
    }

    if (location.indexOf("/") !== -1) {
      location = location.slice(0, location.indexOf("/"));
    }

    switch (location) {
      case "home":
        setActiveTab(document.getElementById("homeLink"));
        break;

      case "conecta":
        setActiveTab(document.getElementById("connectLink"));
        break;
      case "empleos":
        setActiveTab(document.getElementById("empleosLink"));
        break;
      case "vacante":
        setActiveTab(document.getElementById("empleosLink"));
        break;

      case "formacion":
        setActiveTab(document.getElementById("formacionLink"));
        break;

      case "chat":
        setActiveTab(document.getElementById("chatLink"));
        break;

      case "notifications":
        setActiveTab(document.getElementById("notificationsLink"));
        break;

      case "talento":
        setActiveTab(document.getElementById("talentoLink"));
        break;

      default:
        break;
    }
  });

  return (
    <Fragment>
      <header className="header col-1">
        <div className="header__container container ">
          <div className="header_menu row align-items-center ">
            <div className="col-6 col-md-6 col-lg-2 header__logo header__logo--color">
              <div className="header__logoImage temp-logo">
                <img src={krezco} alt="krezco" />
              </div>
            </div>
            <div
              className="col-12 col-md-12 col-lg-8 header__menu"
              id="header-itemconteiner"
            >
              <ul className="list list--icons">
                <li className="nav-link" id="homeLink">
                  <Link to={`${path}/Home`}>
                    <i className="fas fa-home"></i>{" "}
                    <span id="letras">Inicio</span>
                  </Link>
                </li>

                <li className="nav-link" id="connectLink">
                  <Link to={`${path}/Conecta`}>
                    <i class="fas fa-puzzle-piece"></i>
                    <span id="letras">Conecta</span>
                  </Link>
                </li>

                <li className="nav-link" id="empleosLink">
                  <Link to={`${path + endlink}`}>
                    <i className="fas fa-briefcase"></i>{" "}
                    <span id="letras">Empleos</span>
                  </Link>
                </li>

                <li className="nav-link" id="formacionLink">
                  <Link to={`${path + Fendlink}`}>
                    <i className="fas fa-laptop"></i>{" "}
                    <span id="letras">Formación</span>
                  </Link>
                </li>

                {rol !== "applicant" && (
                  <li className="nav-link" id="talentoLink">
                    <Link to={`${path}/Talento`}>
                      <i class="fas fa-handshake"></i>
                      <span id="letras">Talento</span>
                    </Link>
                  </li>
                )}

                {rol !== "applicant" && (
                  <>
                    <li className="nav-link">
                      <a
                        href="#/"
                        style={{ paddingTop: "30px" }}
                        onClick={togglereporte}
                      >
                        <img src={reporte} alt="reporte Icon"></img>{" "}
                        <span id="letras">Reportes</span>
                      </a>
                    </li>

                    <Reporte
                      show={Reportes}
                      companyData={companyData.companyProfileId}
                      onHide={togglereporte}
                      name={companyData.name}
                      userid={localStorage.getItem("userId")}
                    />
                  </>
                )}

                <li className="nav-link" id="chatLink">
                  <Link to={`${path}/chat`}>
                    <i class="fas fa-envelope"></i>
                    <span id="letras">Mensajes</span>
                  </Link>
                </li>

                <li className="nav-link" id="notificationsLink">
                  <Link to={`${path}/notifications`}>
                    <i class="fas fa-bell"></i>
                    <span id="letras" class="">
                      Notificaciones{" "}
                    </span>
                    <span className="notification-icon">
                      {unreadNotificationCount && unreadNotificationCount}{" "}
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-6 col-md-6 col-lg-2 profile__container">
              <div className="dropdown dropdown__profile">
                <button
                  className="btn btn-secondary dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img
                    id="headerProfilePic"
                    src={user}
                    style={pp}
                    alt="Profile Icon"
                  ></img>
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <Link className="dropdown-item" to={`${path}/perfil`}>
                    Ver Perfil
                  </Link>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={() => sinFuncionalidad()}
                  >
                    Configuración y Privacidad
                  </a>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={() => sinFuncionalidad()}
                  >
                    Ayuda
                  </a>

                  <a className="dropdown-item" onClick={logOut} href="#">
                    Cerrar Sesión
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </Fragment>
  );
}

const DATES_R = {
  NO: 0,
  VACANT1: 1,
  VACANT2: 2,
};

function Reporte({ show, onHide, companyData, name, userid }) {
  const [showDates, setShowDates] = useState(DATES_R.NO);

  const testreportCompany = () => {
    axios({
      url: "report/export/" + companyData,
      method: "POST",
      responseType: "blob", // important
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Reportes-" + name + ".xls");
        document.body.appendChild(link);
        link.click();
      })
      .catch(function (error) {
        if (error.response.status === 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
        }
        if (error.response.status === 400) {
          toast.error(error.response.data.message);
        }
      });
  };

  function exportreporte1(_date1, _date2) {
    axios
      .get("reportes/vacant1/" + userid, {
        params: {
          start: _date1,
          end: _date2,
        },
      })
      .then(({ data }) => {
        ExportExcel(data, "Reporte de vacantes tipo 1");
      });
  }

  function exportreporte2(_date1, _date2) {
    axios
      .get("reportes/vacant2/" + userid, {
        params: {
          start: _date1,
          end: _date2,
        },
      })
      .then(({ data }) => {
        ExportExcel(data, "Reporte de vacantes tipo 2");
      });
  }

  function sendReport(date1, date2) {
    let _date1 = moment(date1).add(1, "d").format("DD-MM-YYYY");
    let _date2 = moment(date2).add(1, "d").format("DD-MM-YYYY");

    if (DATES_R.VACANT1 === showDates) {
      exportreporte1(_date1, _date2);
      return;
    }

    exportreporte2(_date1, _date2);
  }

  return (
    <Modal
      show={show}
      keyboard={false}
      onHide={onHide}
      dialogClassName="kr-modal"
      className="ModalReporte"
    >
      <Modal.Body>
        <div className="d-flex justify-content-between">
          <h2>
            {DATES_R.NO === showDates
              ? "REPORTES"
              : DATES_R.VACANT1 === showDates
              ? "Seleccione la fechas para el reporte de vacante 1"
              : "Seleccione la fechas para el reporte de vacante 2"}
          </h2>
          <p onClick={onHide}>X</p>
        </div>

        <div>
          {showDates === DATES_R.NO && (
            <div className="row">
              <div className="col-12 col-md-4 col-lg-4 d-flex justify-content-center">
                <button
                  className="btn btn--gradient"
                  onClick={() => testreportCompany()}
                  style={{ width: "auto" }}
                >
                  Descargar Reporte General
                </button>
              </div>

              <div className="col-12 col-md-4 col-lg-4 d-flex justify-content-center">
                <button
                  className="btn btn--gradient"
                  onClick={() => setShowDates(DATES_R.VACANT1)}
                  style={{ width: "auto" }}
                >
                  Descargar Reporte de vacante 1
                </button>
              </div>
              <div className="col-12 col-md-4 col-lg-4 d-flex justify-content-center">
                <button
                  className="btn btn--gradient "
                  onClick={() => setShowDates(DATES_R.VACANT2)}
                  style={{ width: "auto" }}
                >
                  Descargar Reporte de vacante 2
                </button>
              </div>
            </div>
          )}

          {showDates !== DATES_R.NO && (
            <>
              <p role="button" onClick={() => setShowDates(DATES_R.NO)}>
                {" "}
                <FontAwesomeIcon icon={faArrowLeft} /> Atras
              </p>

              <DatesPicker onOk={sendReport} />
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default HeaderProfile;
